import Auth from './auth/reducer';
import App from './app/reducer';
import ThemeSwitcher from './themeSwitcher/reducer';
import LanguageSwitcher from './languageSwitcher/reducer';
import membershipLevel from '../customApp/redux/membershipLevel/reducer';
import memberPoint from '../customApp/redux/memberPoint/reducer';
import memberTicket from '../customApp/redux/memberTicket/reducer';
import product from '../customApp/redux/product/reducer';
import brand from '../customApp/redux/brand/reducer';
import memberFilter from '../customApp/redux/memberFilter/reducer';
import address from '../customApp/redux/address/reducer';
import member from '../customApp/redux/member/reducer';
import cms from '../customApp/redux/cms/reducer';
import memberList from '../customApp/redux/memberList/reducer';
import memberCampaign from '../customApp/redux/memberCampaign/reducer';
import memberRecycle from '../customApp/redux/memberRecycle/reducer';
import memberTransaction from '../customApp/redux/memberTransaction/reducer';
import codeGenerator from '../customApp/redux/codeGenerator/reducer';
import memberCard from '../customApp/redux/memberCard/reducer';
import menu from '../customApp/redux/menu/reducer';
import permission from '../customApp/redux/permission/reducer';
import pickupActivity from '../customApp/redux/pickupActivity/reducer';
import synchronizedUploadTransaction from '../customApp/redux/synchronizedUploadTransaction/reducer';
import relay from '../customApp/redux/relay/reducer';
import mobileAppConfiguration from '../customApp/redux/mobileAppConfiguration/reducer';
import mission from '../customApp/redux/mission/reducer';
import tag from '../customApp/redux/tag/reducer';
import sale from '../customApp/redux/sale/reducer';
import voucher from '../customApp/redux/voucher/reducer';
import externalCodeGenerator from '../customApp/redux/externalCodeGenerator/reducer';
import receipt from '../customApp/redux/receipt/reducer';
import subscription from '../customApp/redux/subscription/reducer';
import shop from '../customApp/redux/shop/reducer';
import logistic from '../customApp/redux/logistic/reducer';
import homeDeliveryOrder from '../customApp/redux/homeDeliveryOrder/reducer';
import general from '../customApp/redux/general/reducer';
import externalTicket from '../customApp/redux/externalTicket/reducer';
import thirdPartyOrder from '../customApp/redux/thirdPartyOrder/reducer';
import productBatchCode from '../customApp/redux/productBatchCode/reducer';
import inbox from '../customApp/redux/inbox/reducer';

export default {
  Auth,
  App,
  ThemeSwitcher,
  LanguageSwitcher,
  membershipLevel,
  memberPoint,
  memberTicket,
  product,
  brand,
  memberFilter,
  address,
  member,
  cms,
  memberList,
  memberCampaign,
  memberRecycle,
  memberTransaction,
  codeGenerator,
  memberCard,
  menu,
  permission,
  pickupActivity,
  synchronizedUploadTransaction,
  relay,
  mobileAppConfiguration,
  mission,
  tag,
  sale,
  voucher,
  externalCodeGenerator,
  receipt,
  subscription,
  shop,
  logistic,
  homeDeliveryOrder,
  general,
  externalTicket,
  thirdPartyOrder,
  productBatchCode,
  inbox,
};
